export default __webpack_public_path__ + "static/media/logo_urgently_dark.1657c0b7.svg";